import { Spacing } from '@treneo/shared/themes';
import { Skeleton } from '@treneo/shared/ui';

import {
  ActionButtonsContainer,
  CourseDateRow,
  DateTimePickerContainer,
  FormContainer
} from '../styled';

const FormFieldSkeleton = () => <Skeleton variant='rectangular' width='100%' height={56} />;

const CheckboxOptionSkeleton = () => (
  <div style={{ display: 'flex', alignItems: 'center', gap: Spacing.small }}>
    <Skeleton variant='rectangular' width={20} height={20} />
    <Skeleton variant='text' width='60%' height={20} />
  </div>
);

const DateTimeInputGroup = () => (
  <div style={{ display: 'flex', gap: Spacing.xsmall }}>
    <Skeleton variant='rectangular' width={160} height={56} />
    <Skeleton variant='rectangular' width={100} height={56} />
  </div>
);

export const LoadingSkeleton = () => (
  <FormContainer>
    <FormFieldSkeleton />

    <FormFieldSkeleton />

    <div style={{ display: 'flex', gap: Spacing.medium, alignItems: 'center' }}>
      <div style={{ flex: 1 }}>
        <FormFieldSkeleton />
      </div>
      <div style={{ flex: 1 }}>
        <FormFieldSkeleton />
      </div>
      <div style={{ flex: 1 }}>
        <FormFieldSkeleton />
      </div>
    </div>

    <FormFieldSkeleton />

    <CourseDateRow>
      <DateTimePickerContainer>
        <div
          style={{
            display: 'flex',
            gap: Spacing.small,
            alignItems: 'flex-end',
            flexWrap: 'wrap',
            minHeight: 56
          }}
        >
          <DateTimeInputGroup />

          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: `${Spacing.small} 0`,
              minHeight: 56
            }}
          >
            <Skeleton variant='circular' width={24} height={24} />
          </div>

          <DateTimeInputGroup />
        </div>

        <div style={{ minHeight: 20, marginTop: 3, marginLeft: 14, marginRight: 14 }}>
          <Skeleton variant='text' width='40%' height={16} />
        </div>
      </DateTimePickerContainer>
      <ActionButtonsContainer>
        <Skeleton variant='rectangular' width={85} height={36} />
        <Skeleton variant='rectangular' width={105} height={36} />
      </ActionButtonsContainer>
    </CourseDateRow>

    <Skeleton variant='rectangular' width='100%' height={120} />

    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: Spacing.small,
        border: '1px solid rgba(0, 0, 0, 0.23)',
        borderRadius: '4px',
        padding: Spacing.medium
      }}
    >
      <CheckboxOptionSkeleton />
      <CheckboxOptionSkeleton />
      <CheckboxOptionSkeleton />
    </div>

    <div style={{ display: 'flex', gap: Spacing.medium, justifyContent: 'flex-end' }}>
      <Skeleton variant='rectangular' width={100} height={40} />
      <Skeleton variant='rectangular' width={150} height={40} />
    </div>
  </FormContainer>
);
